import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class HeroExchangeRateModal implements AnalyticsObject {
  name: string
  properties: AnalyticsProperties
  constructor() {
    this.name = `Hero Exchange Rate Modal`
    this.properties = {}
  }
}
